import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import Modal from '../../../../Components/Modal/Modal';
import { Button } from '../../../../Components/StyledComponents';
import { convertCost } from '../../../../Utils/functions';
import BreakTime from './Modals/BreakTime';
import Holiday from './Modals/Holiday';
import OperationHour from './Modals/OperationHour';
import PointRate from './Modals/PointRate';
import TempHoliday from './Modals/TempHoliday';
import TempStop from './Modals/TempStop';

//정기 휴일 주기
const RegularCycle = [
    '매주',
    '매월 첫번째',
    '매월 두번째',
    '매월 세번째',
    '매월 네번째',
    '매월 다섯번째',
    '매월 마지막주'
]

//요일
const RegularDay = [
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일',
    '일요일'
]

const OpertaionInfo = () => {
    const [ info, setInfo ] = React.useState({});//운영 정보
    const [ isLoading, setIsLoading ] = React.useState(true)

    const pointRateRef = React.useRef(null);//적립 비율 모달
    const operationRef = React.useRef(null);//운영 시간 모달
    const holidayRef = React.useRef(null);//휴무일 모달
    const breakRef = React.useRef(null);//휴식시간 모달
    const tempHolidayRef = React.useRef(null);//임시 휴무일 모달
    const tempStopRef = React.useRef(null);//임시 영업 중단 모달

    useEffect(() => {
        getOperationInfo()
    },[])

    //운영 정보 get
    const getOperationInfo = () => {
        axios.get('/api/order/info')
        .then((data) => {
            if( typeof data.data.OrderInfo !== 'undefined') setInfo(data.data.OrderInfo)
            setIsLoading(false)
        })
        .catch(() => {
            setIsLoading(false)
        })
    }

    //적립 비율 수정
    const patchPoint = (delivery, pickup, table) => {
        axios.patch('/api/order/info/point_rate',{
            Rate : {
                DeliveryPointRate : delivery,
                PickupPointRate : pickup,
                TablePointRate : table
            }
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                pointRateRef.current.closeModal();
                alertRef.current.showAlert({ title : `적립비율이 수정 되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //운영 시간 수정
    const patchOperationHours = (val) => {
        axios.patch('/api/order/info/operation_hours', {
            OperationHours : {
                Everyday : val.Allday,
                Weekday : val.Weekday,
                Saturday : val.Saturday,
                Sunday : val.Sunday
            }
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                operationRef.current.closeModal();
                alertRef.current.showAlert({ title : '운영시간이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //휴무일 수정
    const patchDayoffs = (val) => {
        axios.patch('/api/order/info/day_offs',{
            DayOffs : {
                Holiday : val.Holiday,
                RegularHolidays : val.RegularHolidays
            }
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                holidayRef.current.closeModal();
                alertRef.current.showAlert({ title : '운영시간이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //휴식시간 수정
    const patchBreakTimes = (val) => {
        axios.patch('/api/order/info/break_times', {
            BreakTimes : {
                isAllday : val.isAllday,
                DayList : val.DayList
            }
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                breakRef.current.closeModal();
                alertRef.current.showAlert({ title : '휴식시간이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //임시 영업 중단 수정
    const patchTempStop = (val) => {
        axios.patch('/api/order/info/temp_stop', {
            TempStop : val
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                tempStopRef.current.closeModal();
                alertRef.current.showAlert({ title : '임시 영업 중단이 설정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `설정 시간을 확인해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //임시 영업중단 해제
    const removeTempStop = () => {
        axios.delete('/api/order/info/temp_stop')
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                alertRef.current.showAlert({ title : '임시 영업 중단이 해제 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //임시 휴무일 수정
    const patchTempHoliday = (val) => {
        axios.patch('/api/order/info/temp_dayoffs',{
            TempDayOffs : val
        })
        .then((data) => {
            if(data.status === 204){
                getOperationInfo();
                tempHolidayRef.current.closeModal()
                alertRef.current.showAlert({ title : '임시 휴일이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //padding string 0
    const convertPad = (val) => {
        return val.toString().padStart(2,'0')
    }

    //시간 2자리수로 padding
    function padBreakTimes(time){
        return '시작 : ' + String(time.StartHour).padStart(2, '0') + ' : ' + String(time.StartMin).padStart(2, '0') + ' ~ ' + '종료 : ' + String(time.EndHour).padStart(2, '0') + ' : ' + String(time.EndMin).padStart(2, '0')
    }

    //시간 2자리수로 padding
    function padTempStop(time){
        return '시작 : ' + String(time.StartHour).padStart(2, '0') + ' : ' + String(time.StartMin).padStart(2, '0') + ' ~ ' + '종료 : ' + String(time.EndHour).padStart(2, '0') + ' : ' + String(time.EndMin).padStart(2, '0')
    }

    return (
        <div>
            {
                !isLoading &&
                <>
                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>매장정보</p>
                            <p className='info-sub-title'>우리 매장의 업종 카테고리를 선택해요.</p>
                        </div>

                        {/* <Button variant="sub" className='edit-btn'>
                            수정하기
                        </Button> */}
                    </div>

                    <div className='header-divider' ></div>

                    <div className='row'>
                        <p className='info-title'>카테고리</p>
                        {
                            typeof info.Category === 'undefined' ?
                            <p className='info-text'>설정된 카테고리가 없습니다.</p>
                            :
                            <p className='info-text'>{info.Category}</p>
                        }
                    </div>
                </div>

                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>적립비율</p>
                            <p className='info-sub-title'>우리 매장의 포인트 적립 비율을 설정해요.</p>
                        </div>

                        <Button variant="sub" className='edit-btn' onClick={() => pointRateRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>

                    <div className='header-divider' ></div>

                    <div className='row'>
                        <p className='info-title'>배달 주문 적립</p>
                        {
                            (typeof info.DeliveryPointRate !== 'undefined') ?
                            <p className='info-text'>{convertCost(info.DeliveryPointRate)}%</p>
                            :
                            <p className='info-text'>0%</p>
                        }
                    </div>

                    <div className='row' style={{ marginTop : 16, marginBottom : 16 }}>
                        <p className='info-title'>포장 주문 적립</p>
                        {
                            typeof info.PickupPointRate !== 'undefined' ?
                            <p className='info-text'>{convertCost(info.PickupPointRate)}%</p>
                            :
                            <p className='info-text'>0%</p>
                        }
                    </div>

                    <div className='row' style={{ marginTop : 16, marginBottom : 16 }}>
                        <p className='info-title'>테이블 주문 적립</p>
                        {
                            typeof info.PickupPointRate !== 'undefined' ?
                            <p className='info-text'>{convertCost(info.TablePointRate)}%</p>
                            :
                            <p className='info-text'>0%</p>
                        }
                    </div>

                    {/* <div className='row'>
                        <p className='info-title'>테이블 주문 적립</p>
                        <p className='info-text'>8%</p>
                    </div> */}
                </div>

                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>운영시간</p>
                            <p className='info-sub-title'>우리 매장의 운영 시간을 설정해요.</p>
                        </div>

                        <Button variant="sub" className='edit-btn' onClick={() => operationRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>

                    <div className='header-divider' ></div>
                    {
                        (typeof info.OperationHours !== 'undefined' && Object.keys(info.OperationHours).length > 0) ?
                        info.OperationHours.Everyday === true ?
                        <div className='row'>
                            <p className='info-title'>모든 요일</p>
                            {
                                info.OperationHours.Weekday.Allday ?
                                <p className='info-text'>24시간 영업</p>
                                :
                                <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                            }
                        </div>
                        :
                        <>
                            <div className='row' style={{ marginBottom : 16 }}>
                                <p className='info-title'>평일</p>
                                {
                                    info.OperationHours.Weekday.Allday ?
                                    <p className='info-text'>24시간 영업</p>
                                    :
                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                                }
                            </div>
                            <div className='row' style={{ marginBottom : 16 }}>
                                <p className='info-title'>토요일</p>
                                {
                                    info.OperationHours.Saturday.Allday ?
                                    <p className='info-text'>24시간 영업</p>
                                    :
                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Saturday.OpenHour)} : {convertPad(info.OperationHours.Saturday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Saturday.CloseHour)} : {convertPad(info.OperationHours.Saturday.CloseMin)}</p>
                                }
                            </div>
                            <div className='row'>
                                <p className='info-title'>일요일</p>
                                {
                                    info.OperationHours.Sunday.Allday ?
                                    <p className='info-text'>24시간 영업</p>
                                    :
                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Sunday.OpenHour)} : {convertPad(info.OperationHours.Sunday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Sunday.CloseHour)} : {convertPad(info.OperationHours.Sunday.CloseMin)}</p>
                                }
                            </div>
                        </>
                        :
                        <p className='info-text'>운영시간을 설정해 주세요.</p>
                    }
                </div>

                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>휴무일</p>
                            <p className='info-sub-title'>우리 매장의 휴무일을 설정해요.</p>
                        </div>

                        <Button variant="sub" className='edit-btn' onClick={() => holidayRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>

                    <div className='header-divider' ></div>
                    
                    {
                        typeof info.DayOffs === 'undefined'  ?
                        <p className='info-text'>설정된 휴일이 없습니다.</p>
                        :
                        <div className='row'>
                            <p className='info-title'>정기휴일</p>
                            <div>
                            {
                                info.DayOffs.RegularHolidays.length === 0 ?
                                <p className='info-text'>설정된 휴일이 없습니다.</p>
                                :
                                info.DayOffs.RegularHolidays.map((data,i) => {
                                    return (
                                        <p key={i} className='info-text'>{data.Interval === 255 ? '매월 마지막' : RegularCycle[data.Interval]} {RegularDay[data.Day]}</p>
                                    )
                                })
                            }
                            </div>
                        </div>
                    }
                    
                    <div className='divider' />

                    <div className='row'>
                        <p className='info-title'>공휴일 휴무</p>
                        {
                            typeof info.DayOffs === 'undefined' ?
                            <p className='info-text'>설정된 휴일이 없습니다.</p>
                            :
                            <p className='info-text'>{info.DayOffs.Holiday ? '휴무' : '미휴무'}</p>
                        }                        
                    </div>
                </div>

                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>휴식시간 (브레이크타임)</p>
                            <p className='info-sub-title'>우리 매장의 휴식시간을 설정해요.</p>
                        </div>

                        <Button variant="sub" className='edit-btn' onClick={() => breakRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>

                    <div className='header-divider' ></div>

                    {
                        (typeof info.BreakTimes === 'undefined')  ?
                        <p className='info-text'>설정된 휴식시간이 없습니다.</p>
                        :
                        info.BreakTimes.isAllday ?
                        <div className='row'>
                            <p className='info-title'>모든요일</p>
                            <p className='info-text'>{padBreakTimes(info.BreakTimes.DayList[0])}</p>
                        </div>
                        :
                        info.BreakTimes.DayList.map((data,i) => {
                            if(data.isActive){
                                return (
                                    <div className='row' key={i} style={{ marginBottom : i === info.BreakTimes.DayList.length - 1 ? 0 : 16 }}>
                                        <p className='info-title'>{RegularDay[data.Day]}</p>
                                        <p className='info-text'>{padBreakTimes(data)}</p>
                                    </div>
                                )
                            }
                        })
                    }
                </div>

                <div className='info-box'>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>임시 영업 중단 / 임시 휴일</p>
                            <p className='info-sub-title'>임시로 영업을 잠시 중단하거나 임시 휴일을 설정해요.</p>
                        </div>
                    </div>

                    <div className='header-divider' ></div>
                    
                    <div className='row between'>
                        <div className='row'>
                            <p className='info-title'>임시 영업 중단</p>
                            {
                                ( (typeof info.TempStop !== 'undefined') && Object.keys(info.TempStop).length > 0) ?
                                <p className='info-text'>{padTempStop(info.TempStop)}</p>
                                :
                                <p className='info-text'>-</p>
                            }
                        </div>
                        {
                             (typeof info.TempStop !== 'undefined') && Object.keys(info.TempStop).length > 0 ?
                            <Button variant="main" style={{ width : 88}} small onClick={() => alertRef.current.showAlert({ title : `임시 영업 중단을 해제하시겠어요?`, isConfirm : true, confirmText : '해제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();removeTempStop()} })}>
                                해제하기
                            </Button>
                            :
                            <Button variant="sub" className='edit-btn' onClick={() => tempStopRef.current.openModal()}>
                                설정하기
                            </Button>
                        }
                    </div>
                    <div className='divider' />

                    <div className='row between'>
                        <div className='row'>
                            <p className='info-title'>임시 휴일</p>
                            <div>
                            {
                                ( (typeof info.TempDayOffs !== 'undefined') && Object.keys(info.TempDayOffs).length > 0 )?
                                info.TempDayOffs.map((item,i) => {
                                    return(
                                        <p key={i} className='info-text'>{item.StartYear + '-' + convertPad(item.StartMonth) + '-' + convertPad(item.StartDay)} 부터 {item.EndYear + '-' + convertPad(item.EndMonth) + '-' + convertPad(item.EndDay)} 까지</p>
                                    )
                                })
                                :
                                <p className='info-text'>-</p>
                            }
                            </div>
                        </div>

                        <Button variant="sub" className='edit-btn' onClick={() => tempHolidayRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>
                </div>
                </>
            }

            <Modal ref={pointRateRef} contentContainer={{ width : 500 }} isHeader title={'적립비율 설정하기'}>
                <PointRate deliveryPoint={info.DeliveryPointRate} pickupPoint={info.PickupPointRate} tablePoint={info.TablePointRate} patchPoint={patchPoint}/>
            </Modal>

            <Modal ref={operationRef} contentContainer={{ width : 449 }} isHeader title={'운영시간 설정하기'}>
                <OperationHour info={info.OperationHours} patchOperationHours={patchOperationHours}/>
            </Modal>

            <Modal ref={holidayRef} contentContainer={{ width : 422}} isHeader title={'휴무일 설정하기'}>
                <Holiday info={info.DayOffs} patchDayoffs={patchDayoffs}/>
            </Modal>

            <Modal ref={breakRef} contentContainer={{ width : 425, height : '80%', overflowY : 'scroll' }} isHeader title={'휴식시간 (브레이크타임) 설정하기'}>
                <BreakTime info={info.BreakTimes} patchBreakTimes={patchBreakTimes}/>
            </Modal>

            <Modal ref={tempHolidayRef} contentContainer={{ width : 500 }} isHeader title={'임시 휴일 설정하기'}>
                <TempHoliday tempDayOffs={info.TempDayOffs} patchTempHoliday={patchTempHoliday}/>
            </Modal>

            <Modal ref={tempStopRef} contentContainer={{ width : 500 }} isHeader title={'임시 영업 중단 설정하기'}>
                <TempStop tempDayOffs={info.TempStop} patchTempStop={patchTempStop}/>
            </Modal>
        </div>
    )
}

export default OpertaionInfo